import { render, staticRenderFns } from "./vehicleoverview.html?vue&type=template&id=322d854b&scoped=true&"
import script from "./vehicleoverview.vue?vue&type=script&lang=js&"
export * from "./vehicleoverview.vue?vue&type=script&lang=js&"
import style0 from "./vehicleoverview.vue?vue&type=style&index=0&id=322d854b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322d854b",
  null
  
)

export default component.exports